const plantSupplyTabs = {
  OLD_BULK_SHIPMENT: "Old shipment upload",
  BULK_SHIPMENT: "Shipment upload",
  PLANT_SUPPLY_TAB: "Plant Supply",
  DO_SHORTCLOSE: "DO short closure approval",
  SHIPMENT_CREATION_PLANT_SUPPLY: "Shipment creation - Plant supply",
  SHIPMENT_CREATION_JODL: "Shipment creation - JODL",
  PURCHASE_BILL: "Purchase bill",
  DO_RELEASE: "DO release",
  FINISHED_GOODS: "Finished Goods",
};
const SO_DETAIL_COLUMN_HEADER = "SO details";
const PLANT_SUPPLY_HEADER = [
  "Buyer’s Order ID",
  "Customer Name",
  "SKU Name",
  "Quantity Ordered",
  "DO Released",
  "Pending invoicing quantity",
  "Price/Unit",
  SO_DETAIL_COLUMN_HEADER,
];
const DO_SHORTCLOSE_HEADER = [
  "DO ID",
  "Sales order ID",
  "SKU name",
  "Released SKU quantity",
  "Dispatched quantity",
  "Residual quantity",
  "Residual value",
  "Released value",
  "Remark",
];
const DO_STATUS = {
  approved: "Approved",
  rejected: "Rejected",
  requested: "Requested",
};

const filterQueries = {
  buyerOrderId: "Buyer's order ID",
  soDetails: "SO details",
};

const SHIPMENT_CREATION_PLANT_SUPPLY_HEADERS = [
  "Order Number",
  "Buyer Name (ERP)",
  "Buyer Name (SAP)",
  "Priority",
  "Invoice Number",
  "Invoice Value",
  "SKU (ERP)",
  "SKU (SAP)",
  "Quantity Invoiced",
  "Invoice posting status",
  "Actions",
];

const SHIPMENT_CREATION_JODL_HEADERS = [
  "Order Number",
  "Seller Order Number",
  "Buyer Name (ERP)",
  "Mode of Shipment",
  "Invoice Number",
  "Invoice Value",
  "SKU (ERP)",
  "Quantity Invoiced",
  "Other Charges",
  "Invoice posting status",
  "Actions",
];

const PURCHASE_BILL_HEADERS = [
  "Order number",
  "PO number",
  "Buyer name (ERP)",
  "Buyer name (SAP)",
  "Priority",
  "SAP invoice number",
  "Purchase bill value",
  "SKU (ERP)",
  "SKU (SAP)",
  "Quantity invoiced",
  "Actions",
];

const BULK_SHIPMENT_CATEGORY = {
  bulkUpload: "Bulk_Upload",
  jodl: "JODL",
  plantSupply: "JOPL",
  PO: "PO",
  jots: "JOTS",
};

const SHIPMENT_STATUS = {
  pending: "PENDING",
  approved: "APPROVED",
  rejected: "REJECTED",
  inProgress: "IN-PROCESS",
  failed: "FAILED",
  created: "CREATED",
};

const STATUS_STATES = {
  requested: "Requested",
  approved: "Approved",
  rejected: "Rejected",
};

const ORDER_CATEGORIES = {
  Distributed: "DISTRIBUTED",
  "Private Brand (PB)": "PRIVATE BRAND",
  "Plant Supply": "PLANT SUPPLY",
};

const QUICK_FILTERS = {
  Pending: "PENDING",
  All: null,
  "Have error": "HAVE_ERROR",
  Created: "CREATED",
  // Approved: "APPROVED",
  Rejected: "REJECTED",
};

const PURCHASE_BILL_QUICK_FILTERS = {
  Pending: "PENDING",
  "Have error": "HAVE_ERROR",
  Created: "CREATED",
  Rejected: "REJECTED",
  All: null,
};

const OTHER_CHARGES_HEADERS = [
  "Service Sku",
  "Base Amount",
  "Tax Amount",
  "Total",
];

const DO_RELEASE_QUICK_FILTERS = {
  All: null,
  Pending: "PENDING",
  Approved: "APPROVED",
  Released: "RELEASED",
  Rejected: "REJECTED",
  "Pre-emptive DO": true,
};

const INVENTORY_STATUS = {
  mapped: "MAPPED",
  released: "RELEASED",
  unMapped: "UNMAPPED",
  softDelete: "SOFT_DELETE",
};

const DO_RELEASE_HEADERS = [
  "Order Number",
  "Customer Name",
  "SAP SKU Name, SO number, SO line item number",
  "ERP SKU Name",
  "Priority",
  "FG Quantity",
  "DO Quantity",
  "Payment Request",
  "Credit Request",
  "Order Type",
  "Material Short Description",
  "Rate (Excluding Tax)",
  "Status",
  "FG readiness date",
  "Actions",
];

const INVERNTORY_QUICK_FILTERS = {
  All: null,
  Unreserved: "UNRESERVED",
  "Awaiting release": "AWAITING_RELEASE",
  Released: "RELEASED",
  "Soft deleted": "SOFT_DELETED",
  "Awaiting funds": "AWAITING_FUNDS",
};

const INVENTORY_TABLE_HEADERS = [
  "Inventory type",
  "SAP SKU name",
  "SO number",
  "SO line item number",
  "Mapped order",
  "Quantity",
  "Expected FG date",
  "Status",
  "",
];

const UPLOAD_FILES_HEADERS = [
  "File name",
  "Upload Date and Time",
  "File status",
  "Failed Records",
];

const SHIPMENT_REPORT_TYPES = [
  { value: "MTO", label: "JSW Steel MTO FG Upload" },
  { value: "MTS", label: "MTS FG (PB, T1S, JSW Steel)" },
];

const EXPECTED_FG_DATE_TYPES = [
  { value: "Today", label: "Today" },
  { value: "Next 3 days", label: "Next 3 days" },
  { value: "Next 7 days", label: "Next 7 days" },
];

const jodlShipmentMappingHeader = [
  "",
  "Truck number",
  "Timestamp",
  "Shipment number",
  "Seller name",
  "Pick-up location",
];

const PICKUP_DETAILS_UPDATE_SUCCESS_MSG =
  "Pick Up details updated successfully";

export {
  plantSupplyTabs,
  SO_DETAIL_COLUMN_HEADER,
  DO_SHORTCLOSE_HEADER,
  PLANT_SUPPLY_HEADER,
  filterQueries,
  DO_STATUS,
  QUICK_FILTERS,
  SHIPMENT_CREATION_PLANT_SUPPLY_HEADERS,
  SHIPMENT_CREATION_JODL_HEADERS,
  BULK_SHIPMENT_CATEGORY,
  SHIPMENT_STATUS,
  OTHER_CHARGES_HEADERS,
  STATUS_STATES,
  ORDER_CATEGORIES,
  PURCHASE_BILL_HEADERS,
  DO_RELEASE_QUICK_FILTERS,
  INVENTORY_STATUS,
  DO_RELEASE_HEADERS,
  INVERNTORY_QUICK_FILTERS,
  INVENTORY_TABLE_HEADERS,
  UPLOAD_FILES_HEADERS,
  SHIPMENT_REPORT_TYPES,
  EXPECTED_FG_DATE_TYPES,
  jodlShipmentMappingHeader,
  PICKUP_DETAILS_UPDATE_SUCCESS_MSG,
  PURCHASE_BILL_QUICK_FILTERS,
};
